import { HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';

export function blobToJsonError(errorResponse: HttpErrorResponse): Observable<never> {
    return new Observable<never>((subscriber) => {
        const reader = new FileReader();
        reader.onload = () => {
            try {
                const jsonError = JSON.parse(reader.result as string);
                const error: HttpErrorResponse = { ...errorResponse, error: jsonError };

                subscriber.error(error);
            } catch (e) {
                subscriber.error(errorResponse);
            }
        };
        reader.onerror = () => {
            subscriber.error(errorResponse);
        };
        reader.readAsText(errorResponse.error);
    });
}
